export default __webpack_public_path__ + "static/media/panzer.c72309bf.mkv";